export default __webpack_public_path__ + "static/6-8f3d820fb5a10cc767deda6250ecd10d.jpg";